/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseValidator} from "./BaseValidator";

export class PasswordsMatchValidator extends BaseValidator {
	constructor() {
		super();
	}

	name(model) {
		return "Password"
	}

	logic(x) {
		return x !== false;
	}

	message() {
		return "Passwords Must Match"
	}
}